'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var Warning = function (_React$Component) {
    _inherits(Warning, _React$Component);

    function Warning() {
        _classCallCheck(this, Warning);

        return _possibleConstructorReturn(this, (Warning.__proto__ || Object.getPrototypeOf(Warning)).apply(this, arguments));
    }

    _createClass(Warning, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M25.153 23.282l-10.015-17.346c-0.47-0.814-1.346-1.32-2.286-1.32s-1.816 0.506-2.286 1.32l-10.096 17.488c-0.47 0.814-0.47 1.825 0 2.639s1.346 1.32 2.286 1.32h20.182c0.005 0 0.011 0 0.015 0s0.007 0 0.009 0c1.452-0.004 2.632-1.186 2.632-2.64 0-0.523-0.152-1.028-0.441-1.461zM22.955 26.21c-0.002 0-0.004 0-0.005 0h-20.194c-0.522 0-1.009-0.281-1.27-0.733s-0.261-1.014 0-1.466l10.097-17.488c0.261-0.452 0.748-0.733 1.27-0.733s1.008 0.281 1.27 0.733l10.025 17.363c0.007 0.012 0.015 0.025 0.023 0.036 0.166 0.242 0.252 0.527 0.252 0.822-0.001 0.809-0.659 1.466-1.468 1.466zM12.855 20.085c0.344 0 0.824-0.235 0.854-0.854l0.293-6.842c0-0.634-0.514-1.147-1.147-1.147s-1.147 0.514-1.147 1.147l0.293 6.842c0.034 0.651 0.469 0.854 0.854 0.854zM12.855 21.050c-0.387 0-0.765 0.158-1.038 0.431s-0.428 0.649-0.428 1.036c0 0.388 0.155 0.765 0.428 1.038s0.651 0.428 1.038 0.428c0.387 0 0.765-0.155 1.035-0.428 0.276-0.272 0.431-0.651 0.431-1.038 0-0.384-0.155-0.762-0.431-1.036-0.269-0.272-0.648-0.431-1.035-0.431z' })
            );
        }
    }]);

    return Warning;
}(_react2.default.Component);

Warning.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = Warning;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/warning.js
// module id = 1132
// module chunks = 0